
// 品牌主页
const brandOwners = () => import(/* webpackChunkName: "Index" */ '@/views/brandOwnersModule/index')

const brandOwnersRouter = [
    {
      path: '/index',
      redirect: '/admin/home',
      component: () => import('@/views/loginModule/index'),
      children: [
        {
          path: '/admin/brandOwners',
          name: 'brandOwners',
          component: brandOwners,
          meta: {
            title: '品牌主'
          }
        }
      ]
    }
  ]
  export default brandOwnersRouter
  
